import { LocalStorage } from '../localStorage/storage.svelte'

export type UiScaleValue = 'small' | 'normal'

export interface UiScaleConfig {
	value: UiScaleValue
	scale: number
}

export const uiScaleOptions: UiScaleConfig[] = [
	{ value: 'small', scale: 0.9 },
	{ value: 'normal', scale: 1.0 },
]

export const uiScale = new LocalStorage<UiScaleValue>('ui-scale', 'normal')

export function getCurrentScale(): number {
	const currentValue = uiScale.current
	return uiScaleOptions.find((option) => option.value === currentValue)?.scale || 1.0
}

export function applyScale(scale: number) {
	document.documentElement.style.setProperty('--scale-global', scale.toString())
}
